var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"11","sm":"8","md":"4"}},[_c('v-alert',{attrs:{"border":"right","colored-border":"","type":"error","elevation":"2"}},[_c('h3',[_vm._v(" It looks like you've lost your connection to the internet. Please check your connection and try again. ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }